export default "__VITE_ASSET__7934640e__"